import React from 'react';
import {Link, withRouter} from "react-router-dom";
import {inject, observer } from 'mobx-react'
import {Logo} from 'components/svgs/NonLoggedUserLogo';

@inject('user')
@observer
class NavBar extends React.Component {

  state = {signIn: true, display: 'block'};


  componentWillMount = () => {
    this.handlePathName(this.props.location);
    this.routerListener = this.props.history.listen((location, action) => {
     this.handlePathName(location);
    });
  };

  componentWillUnmount = () => {
    this.routerListener();
  };

  signUpLink = () => {
    return (
      <div className="create-holder">
        <span className="create-desc">Have an account?</span>
        <Link to="/newuser/signin" className="btn prime bordered create-btn">sign in</Link>
      </div>
    );
  };

  handlePathName = location => {
    if(location.pathname.includes('signin'))
      this.setState({signIn: true});
    else
      this.setState({signIn: false});

    if(location.pathname.includes('forgotpassword') || location.pathname.includes('passwordrecovery')){
      this.setState({display: 'none'})
    }
    else {
      this.setState({display: 'block'})
    }
  };

  signInLink = () => {
    return (
      <div className="create-holder">
        <span className="create-desc"> Dont have an account?</span>
        <Link to="/newuser/signup" className="btn prime bordered create-btn">sign up</Link>
      </div>
    );
  };

  render() {
    return(
      <header className="main-header sign-up-header" id="newUser">
        <div className="container-fluid">
          <div className="row justify-content-between">
            <div className="col-6 col-md-2">
              <Link to="/" className="logo">
                {Logo}

              </Link>
            </div>
            <div className="col-6 col-md-4 offset-md-6" style={{display: this.state.display}}>
              { this.state.signIn ? this.signInLink() : this.signUpLink() }
            </div>
          </div>
        </div>
      </header>

    );
  }
}

export default withRouter(NavBar);



// WEBPACK FOOTER //
// ./src/components/new_user/NavBar.jsx